import React from "react";
import "./InterviewDetailNew.scss";
import { Steps, Toast, WingBlank, Button, Tag, Modal } from "antd-mobile";
import http from "../../util/api";
import GoBack from "../../components/GoBack";
import { getItem } from "../../util/util";
import withAuth from "../../HOCs/withAuth";
import moment from "moment";

//C3_617294701291 个人信息是否提交

const alert = Modal.alert;
const { Step } = Steps;

const resid = "617278498676";
class InterviewDetailNew extends React.Component {
  state = {
    interviewDetail: {},
    componayGuid: JSON.parse(getItem("componay_guide")),
    loading: true
  };

  async componentDidMount() {
    this.setState({
      loading: true
    });
    window.V5CHAT("hideBtn");
    Toast.loading("loading...", 0);
    const id = this.props.match.params.id;
    await this.getInterviewDetail(id);
    this.setState({
      loading: false
    });
  }

  //取消面试
  cancelInterview = async () => {
    try {
      let res = await http().modifyRecords({
        resid,
        data: [{ ...this.state.interviewDetail, isOrdered: "N" }]
      });
      this.setState({ interviewDetail: res.data.data[0] });
      Toast.info("面试已取消");
    } catch (error) {
      console.log(error.message);
      Toast.fail(error.message);
    }
  };

  //获取面试详情
  getInterviewDetail = async id => {
    try {
      let res = await http().getTable({
        resid,
        cmswhere: `interviewId = ${id}`
      });
      let { data } = res;
      if (data.data.length) {
        this.setState({ interviewDetail: data.data[0] });
        Toast.hide();
      } else {
        Toast.info("无面试信息", 2, () => {
          this.props.history.push("/interviews");
        });
      }
    } catch (error) {
      console.log(error.message);
      Toast.fail(error.message);
    }
  };

  goBack = () => this.props.history.push("/interviews");

  startTest = async () => {
    const { interviewDetail } = this.state;
    try {
      Toast.loading();
      await http().modifyRecords({
        resid: "617190472818",
        data: [
          {
            REC_ID: interviewDetail.REC_ID,
            C3_617724261149: moment().format("YYYY-MM-DD HH:mm:ss"),
            C3_635021377996: "Y"
          }
        ]
      });
      Toast.hide();
      this.props.history.push("/answer_questions/" + interviewDetail.batchId);
    } catch (error) {
      console.log(error.message);
      Toast.fail(error.message);
    }
  };

  render() {
    const { interviewDetail, componayGuid } = this.state;
    interviewDetail && console.log(interviewDetail);
    const testStartTime = interviewDetail.C3_617724261149; //考试开始时间
    const isSubmitPersoninfo = interviewDetail.C3_617294701291 === "Y"; //个人信息是否提交
    let current = 0;
    let testResultStatus, interviewResultStatus;
    if (interviewDetail.testResult) {
      current = 1;
      if (interviewDetail.testResult === "通过") {
        testResultStatus = "finish";
      } else if (interviewDetail.testResult === "未通过") {
        testResultStatus = "error";
        interviewResultStatus = "error";
      }
    }
    if (interviewDetail.interviewResult) {
      current = 2;
      if (interviewDetail.interviewResult === "合格") {
        interviewResultStatus = "finish";
      } else if (interviewDetail.interviewResult === "不合格") {
        interviewResultStatus = "error";
      }
    }
    const isWaitingInterview = interviewDetail.C3_617728767339 === "待面试";
    const isValid = interviewDetail.C3_617728767339 !== "已取消";
    let element = null;
    if (!testStartTime) {
      element = (
        <div style={{ padding: "32px 60px" }}>
          <Button type="primary" onClick={this.startTest}>
            开始考试
          </Button>
        </div>
      );
    } else if (!isSubmitPersoninfo) {
      element = (
        <div style={{ padding: "32px 60px" }}>
          <Button
            type="primary"
            onClick={() => this.props.history.push("/editinfo")}
          >
            完善个人详细信息
          </Button>
        </div>
      );
    } else if (
      interviewDetail.testResult === "通过" &&
      !interviewDetail.interviewResult
    ) {
      element = <p className="result-tip">请保持联系方式通畅以接收面试通知</p>;
    } else if (
      interviewDetail.testResult === "未通过" &&
      !interviewDetail.interviewResult
    ) {
      element = (
        <p className="result-tip">
          您未通本次过考试
          <br />
          您可以从{moment(interviewDetail.C3_626465501732).format("YYYY-MM-DD")}
          开始再次申请该职位
        </p>
      );
    } else if (interviewDetail.interviewResult === "合格") {
      element = (
        <p className="result-tip">
          已通过面试 <br />
          请保持联系方式畅通等待入职通知
        </p>
      );
    } else if (interviewDetail.interviewResult === "不合格") {
      element = (
        <p className="result-tip">
          您未通本次过面试
          <br /> 您可以从
          {moment(interviewDetail.C3_626465501732).format("YYYY-MM-DD")}
          开始再次申请该职位
        </p>
      );
    }
    return this.state.loading ? (
      <div />
    ) : (
      <div className="interview-detail-new">
        <GoBack goBack={this.goBack} />
        <div>
          <div className="position_info">
            <div className="title_salary">
              <span className="pisition_title"> {interviewDetail.job}</span>
              <span className="position_salary">
                {interviewDetail.salary}/月
              </span>
            </div>
            {isValid && (
              <>
                <div className="steps">
                  <Steps current={current} direction="horizontal">
                    <Step status={testResultStatus} title="在线考试" />
                    <Step status={interviewResultStatus} title="在线面试" />
                  </Steps>
                </div>
                {element}
              </>
            )}
          </div>
          {
            <div className="interview_infos">
              {isValid ? (
                <React.Fragment>
                  <div>
                    <span>面试时间</span>
                    <span>{interviewDetail.interviewTime}</span>
                  </div>
                  <div>
                    <span>考试时间</span>
                    <span>{interviewDetail.C3_617724261149}</span>
                  </div>
                  <div>
                    <span>考试结果</span>
                    <span
                      className={
                        interviewDetail.testResult === "通过"
                          ? "interview-success "
                          : "interview-failure"
                      }
                    >
                      {interviewDetail.testResult}
                    </span>
                  </div>
                  <div>
                    <span>面试结果</span>
                    <span
                      className={
                        interviewDetail.interviewResult === "合格"
                          ? "interview-success "
                          : "interview-failure"
                      }
                    >
                      {interviewDetail.interviewResult}
                    </span>
                  </div>
                </React.Fragment>
              ) : (
                <div className="interview_not_valid">面试已取消</div>
              )}
            </div>
          }
          <div className="enterprise_info">
            <h4>公司向导</h4>
            <p>
              <span>地址:</span> {componayGuid.address}
            </p>
            <p>
              <span>公交:</span> {componayGuid.transit}
            </p>
            <p>
              <span>电话:</span> {componayGuid.phone}
            </p>
          </div>
          <div className="position_descrition">
            <h3>职位描述</h3>
            <div className="description_main">
              <p>{interviewDetail.jobDis}</p>
              <div className="position_tags">
                {interviewDetail.C3_617811708424 &&
                  interviewDetail.C3_617811708424.split(",").map(item => (
                    <Tag key={item}>{item}</Tag>
                  ))}
              </div>
            </div>
          </div>
          {isWaitingInterview && (
            <WingBlank className="cancel_btn">
              <Button
                onClick={() =>
                  alert("取消预约?", "", [
                    { text: "取消", onPress: () => {} },
                    { text: "确认", onPress: this.cancelInterview }
                  ])
                }
                type="warning"
              >
                取消面试
              </Button>
            </WingBlank>
          )}
        </div>
      </div>
    );
  }
}

export default withAuth(InterviewDetailNew);
